import React from 'react';
import DescribeMealContainer from './DescribeMealContainer';
import { TrackerExtractIngredientsConnectorApollo } from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';

const DescribeMealPage = () => {
  const location = useLocation();

  return (
    <TrackerExtractIngredientsConnectorApollo>
      {({ extractIngredients, cancelExtractIngredients }) => (
        <DescribeMealContainer
          extractIngredients={extractIngredients}
          cancelExtractIngredients={cancelExtractIngredients}
          key={location.key} // Force re-render
        />
      )}
    </TrackerExtractIngredientsConnectorApollo>
  );
};

export default DescribeMealPage;
